function initMenu() {
	//Menu
	$('ul.main-menu .link-type-submenu').on('click', function () {
		if (window.matchMedia('(max-width: 1199px)').matches) {
			$(this).siblings('.submenu').slideToggle();
			$(this).parent().siblings().children('.submenu').slideUp();
		} else {
			$(this).siblings('.submenu').fadeToggle();
			$(this).parent().siblings().children('.submenu').fadeOut();
		}

		$(this).toggleClass('open');
		$(this).parent().siblings().children('.link-type-submenu').removeClass('open');
	});

	const $menuInline = $('.menu-inline');
	const $menuToggle = $('.menu-toggle');
	// Menu toggle
	$menuToggle.on('click', function () {
		$menuInline.fadeToggle();
		$menuToggle.toggleClass('open');
	});

	clickedOutside('ul.main-menu', function () {
		$('ul.main-menu .submenu').fadeOut();
		$('ul.main-menu .submenu').slideUp();
		$('ul.main-menu .link-type-submenu').removeClass('open');
	});

	clickedOutside('.menu-inline', function () {
		$menuInline.fadeOut();
		$menuToggle.removeClass('open');
	}, '.menu-toggle');
}
